var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModule',_vm._b({attrs:{"data-module":"image-full-width","background-color":"#fff"}},'BaseModule',_vm.$props,false),[_c('EditorLink',{attrs:{"model":_vm.linkUrl}},[_c('LImage',{staticClass:"image-full-width",attrs:{"src":_vm.deviceImages,"alt":_vm.deviceAlt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }